<template>
  <!--	노션 링크 : https://www.notion.so/GallerysoyiPage-75a67cc05ca9443b85cad4e2bc7442b3 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="architecturalart_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">GUIDE PROGRAM</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container contentDesc">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <div class="title1">
            <h2>
              <strong>{{ $t('guidep_title') }}</strong>
            </h2>
          </div>
          <div class="title2">
            <h4>{{ $t('guidep_subtitle1') }}</h4>
          </div>
          <div class="title3">
            <p>{{ $t('guidep_subtitle2') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row d-flex">
        <div class="imgContainer col-lg-6 col-md-6 mb-5" align="center">
          <img src="@/assets/images/Podohotel/architecturalart_bodyimage01.jpg" />
        </div>
        <div class="imgContainer col-lg-6 col-md-6">
          <div :class="{anotherword: isLang === 0 || isLang === 1}">
            <div :class="{jpword: isLang === 2}">
              <img src="@/assets/images/Podohotel/architecturalart_bodyimage02.png" v-show="isLang === 0" />
              <img src="@/assets/images/Podohotel/architecturalart_bodyimage02_en.png" v-show="isLang === 1" />
              <img src="@/assets/images/Podohotel/architecturalart_bodyimage02_jp.png" v-show="isLang === 2" />
              <p class="mt-5">
                {{ $t('guidep_body_desc1') }}
              </p>
              <p class="mb-5">
                {{ $t('guidep_body_desc2') }}
              </p>
            </div>
          </div>

          <div class="innerImg mb-3" align="center">
            <img src="@/assets/images/Podohotel/architecturalart_bodyimage03.jpg" />
            <img src="@/assets/images/Podohotel/architecturalart_bodyimage04.jpg" />
          </div>

          <div :class="{anotherword: isLang === 0 || isLang === 1}">
            <table class="table table-borderless mb-5">
              <tbody>
                <tr>
                  <td colspan="2">
                    <h4 style="margin-bottom: 0"><strong>PROGRAM</strong></h4>
                  </td>
                </tr>
                <tr style="border-bottom: 1px dashed #acacac">
                  <th width="27%">{{ $t('guidep_body_table1_td1') }}</th>
                  <td>{{ $t('guidep_body_table1_td2') }}</td>
                </tr>
                <tr style="border-bottom: 1px dashed #acacac">
                  <th>{{ $t('guidep_body_table1_td3') }}</th>
                  <td>{{ $t('guidep_body_table1_td4') }}</td>
                </tr>
              </tbody>
            </table>

            <h4 Style="margin-left: 10px; margin-bottom: 20px"><strong>RESERVATION</strong></h4>
            <table class="table table-borderless mb-5">
              <tbody>
                <tr>
                  <td colspan="2">
                    <h5 style="margin-bottom: 0">
                      <strong>{{ $t('guidep_body_table2_subtitle') }}</strong>
                    </h5>
                  </td>
                </tr>
                <tr style="border-bottom: 1px dashed #acacac">
                  <th width="27%">{{ $t('guidep_body_table2_td1') }}</th>
                  <td>{{ $t('guidep_body_table2_td2') }}</td>
                </tr>
                <tr style="border-bottom: 1px dashed #acacac">
                  <th>{{ $t('guidep_body_table2_td3') }}</th>
                  <td>{{ $t('guidep_body_table2_td4') }}</td>
                </tr>
                <tr style="border-bottom: 1px dashed #acacac">
                  <th>{{ $t('guidep_body_table2_td5') }}</th>
                  <td v-html="$t('guidep_body_table2_td6')"></td>
                </tr>
                <tr style="border-bottom: 1px dashed #acacac">
                  <th>{{ $t('guidep_body_table2_td7') }}</th>
                  <td>{{ $t('guidep_body_table2_td8') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row pt-5" style="background-color: #f5f5f5" v-show="isLang === 0">
        <div :class="{anotherword: isLang === 0 || isLang === 1}" class="col-12">
          <div class="col-12 pb-3" align="center">
            <b-icon scale="2%" icon="exclamation-circle-fill" style="margin-bottom: 30px"></b-icon>
            <h2 style="margin-bottom: 30px"><strong>가이드 QR 서비스 안내</strong></h2>
            <p style="line-height: 2">
              원하는 시간에 자유롭게 이용할 수 있는 가이드 QR 서비스를 새롭게 시행합니다.<br />
              가이드 음성에 따라 장소를 이동하며 포도호텔 건축물을 감상하실 수 있습니다.
            </p>
            <br />
            <p style="line-height: 2">
              ※ 해당 서비스는 투숙객 전용 서비스입니다.<br />
              ※ 이용을 원하실 경우, 프론트로 문의하여 주시기 바랍니다.
            </p>
          </div>
        </div>
      </div>

      <div class="row d-flex justify-content-center mt-5 mb-5">
        <h1 style="margin-bottom: 20px">
          <strong>{{ $t('guidep_video_title') }}</strong>
        </h1>

        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            class="embed-responsive-item"
            src="https://player.vimeo.com/video/300665662?color=ffffff&title=0&byline=0&portrait=0"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'Architecturalart',
  data() {
    return {
      architecturalart_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'FACILITIES',
        present: this.$t('breadcrumb'),
      },
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.architecturalart_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'FACILITIES',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
.jpword {
  word-break: break-all;
}
.anotherword {
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  td {
    word-break: keep-all;
  }
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Podohotel/architecturalart_headerimage.jpg');
  }
  .imgContainer {
    > img {
      width: 100%;
    }
    .innerImg {
      display: flex;
      justify-content: space-between;
      > img {
        width: 45%;
      }
    }
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
  .imgContainer {
    > img {
      width: 100%;
    }
    .innerImg {
      display: flex;
      justify-content: space-between;
      > img {
        width: 45%;
      }
    }
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "건축예술가이드",
    "guidep_title": "건축 예술 가이드",
    "guidep_subtitle1": "포도호텔의 아름다운 건축미를 감상하는 시간",
    "guidep_subtitle2": "세계적인 건축가 이타미 준이 포도호텔에 남긴 예술을 따라 걸어보세요.",
    "guidep_body_desc1": "포도송이를 닮은 독특한 호텔 외관, 갤러리를 연상케 하는 실내 곳곳에는 건축가 이타미 준의 자연주의 철학과 예술 정신이 녹아 있습니다.",
    "guidep_body_desc2": "투숙객을 위한 프로그램 [건축예술 가이드]는 우리가 무심코 지나칠 수 있는 작품의 의미를 공유하고 나아가 머무는 공간의 가치를 전달 합니다. 가이드의 안내와 설명을 통해 마치 하나의 예술 작품 속에 머무는 듯한 설렘을 느껴 보시기 바랍니다.",
    "guidep_body_table1_td1": "소요시간",
    "guidep_body_table1_td2": "약 40분",
    "guidep_body_table1_td3": "내용",
    "guidep_body_table1_td4": "포도호텔 내 외부 디자인 요소 및 건축의미 설명",
    "guidep_body_table2_subtitle": "투숙객",
    "guidep_body_table2_td1": "시간",
    "guidep_body_table2_td2": "오후 5시 (1일 1회)",
    "guidep_body_table2_td3": "참가비",
    "guidep_body_table2_td4": "무료",
    "guidep_body_table2_td5": "접수",
    "guidep_body_table2_td6": "체크인 시 프런트 현장접수 (선착순)",
    "guidep_body_table2_td7": "문의",
    "guidep_body_table2_td8": "064-793-7000",
    "guidep_video_title": "프로그램 소개"
  },
  "en": {
    "breadcrumb": "Guide Program",
    "guidep_title": "Guide Program",
    "guidep_subtitle1": "Time to appreciate the beautiful architecture of PODO Hotel",
    "guidep_subtitle2": "Walk along the art that the world-renowned architect, Itami Jun, left in PODO Hotel.",
    "guidep_body_desc1": "The unique appearance of the hotel resembling a bunch of grapes and the interior spaces suggestive of galleries are imbued with the architect Itami Jun's naturalist philosophy and artistic spirit.",
    "guidep_body_desc2": "[Architectural Art Guide], the program for guests shares the meaning of the works that we can easily overlook and conveys the value of the space in which we stay. Feel as if you are staying in one of the artworks through the guidance and explanation of the professional curator.",
    "guidep_body_table1_td1": "Time Required",
    "guidep_body_table1_td2": "Approximately 40 minutes",
    "guidep_body_table1_td3": "Contents",
    "guidep_body_table1_td4": "Inside PODO Hotel",
    "guidep_body_table2_subtitle": "PODO Hotel guests only",
    "guidep_body_table2_td1": "Hours",
    "guidep_body_table2_td2": "5:00 pm (once a day)",
    "guidep_body_table2_td3": "Participation Fee",
    "guidep_body_table2_td4": "Free",
    "guidep_body_table2_td5": "Reservation",
    "guidep_body_table2_td6": "Front desk upon check-in<br/>(first-come-first-served)",
    "guidep_body_table2_td7": "Inquiry",
    "guidep_body_table2_td8": "+82-64-793-7000",
    "guidep_video_title": "Program introduction"
  },
  "ja": {
    "breadcrumb": "建築芸術ガイド",
    "guidep_title": "建築芸術ガイド",
    "guidep_subtitle1": "ポドホテルの美しい建築美を鑑賞するひと時",
    "guidep_subtitle2": "世界的な建築家伊丹潤がポドホテルに残した芸術を歩いて巡ってください。",
    "guidep_body_desc1": "ブドウの房に似た独特なホテルのエクステリア、ギャラリーを連想させる室内のあちこちに建築家伊丹潤の自然主義哲学と芸術精神が溶け込んでいます。",
    "guidep_body_desc2": "宿泊客のためのプログラム［建築芸術ガイド］は、ともすれば見逃してしまうような作品の意味を共有し滞在する空間の価値をお伝えします。ガイドによる案内と説明を通じて、一つの芸術作品の中にいるようなときめきを感じてください。",
    "guidep_body_table1_td1": "所要時間",
    "guidep_body_table1_td2": "約40分",
    "guidep_body_table1_td3": "内容",
    "guidep_body_table1_td4": "ポドホテル内外のデザイン要素と建築の意味を説明",
    "guidep_body_table2_subtitle": "ポドホテルに宿泊のお客様限定",
    "guidep_body_table2_td1": "日時",
    "guidep_body_table2_td2": "午後5時（1日1回）",
    "guidep_body_table2_td3": "参加費",
    "guidep_body_table2_td4": "無料",
    "guidep_body_table2_td5": "予約",
    "guidep_body_table2_td6": " チェックイン時のフロント、<br/>当日受付（先着順）",
    "guidep_body_table2_td7": "お問い合わせ",
    "guidep_body_table2_td8": "+82-64-793-7000",
    "guidep_video_title": "番組の紹介"
  }
}
</i18n>
